import MainDetailsFooter from "#core/components/main-details/MainDetailsFooter"
import { UseJobProfileDetailsContexts } from "#job-profile/contexts/JobProfileDetailsContexts"

export default function JobProfileDetailsFooter() {
	const { jobProfile } = UseJobProfileDetailsContexts()
	if (!jobProfile) return null

	return <MainDetailsFooter data={jobProfile} />
}
